import { useSwitchNetwork } from 'wagmi';
import { handleWalletError } from '../error/handleWalletError';
export function useWalletSwitchNetWork(params) {
    return useSwitchNetwork({
        throwForSwitchChainNotSupported: true,
        onError: handleWalletError,
        ...params,
    });
}
